var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-notes-upload") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDE4B\\u200D\\u2642\\uFE0F-Punters",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Punters_Notes",
    transform: "translate(-768.000000, -1118.000000)",
    fill: "#102534",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M782.847439,1129.41298 C783.490135,1129.41298 784,1129.92389 784,1130.56712 L784,1130.56712 L784,1134.84512 C784,1135.48911 783.489379,1136 782.847439,1136 L782.847439,1136 L769.152561,1136 C768.509865,1136 768,1135.48835 768,1134.84512 L768,1134.84512 L768,1130.56712 C768,1129.92314 768.510621,1129.41224 769.152561,1129.41224 C769.795257,1129.41224 770.305122,1129.92389 770.305122,1130.56712 L770.305122,1130.56712 L770.305122,1133.69016 L781.694916,1133.6909 L781.694916,1130.56786 C781.694916,1129.92387 782.205537,1129.41298 782.847477,1129.41298 Z M775.197159,1118.34047 C775.65096,1117.88651 776.368912,1117.88651 776.821957,1118.34047 L776.821957,1118.34047 L780.619122,1122.12521 C781.072167,1122.57993 781.072167,1123.29932 780.619122,1123.75328 C780.392599,1123.98027 780.109257,1124.09413 779.806723,1124.09413 C779.504189,1124.09413 779.220846,1123.98026 778.994324,1123.75328 L778.994324,1123.75328 L777.162195,1121.91746 L777.162195,1130.03774 C777.162195,1130.68173 776.651574,1131.19262 776.009634,1131.19262 C775.366938,1131.19262 774.857073,1130.68097 774.857073,1130.03774 L774.857073,1130.03774 L774.857073,1121.93658 L773.024811,1123.77259 C772.571747,1124.22654 771.853795,1124.22654 771.40075,1123.77259 C770.947704,1123.31787 770.947704,1122.59848 771.40075,1122.14452 L771.40075,1122.14452 Z",
    id: "ic-notes-upload"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDark);
export default __webpack_public_path__ + "static/media/upload-dark.a92c5b48e843d7190c6129e8f1fe7b92.svg";
export { ForwardRef as ReactComponent };